import React, { Component } from 'react';
import { Query } from 'react-apollo';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { withRouter } from 'react-router-dom';
import { Loading } from '../../../../../components/Loading';
import { growlErrors } from '../../../../../utils/NotificationUtil';
import ImportFileDetail from './ImportFileDetail';
import { withGrowl } from '../../../../../components/GrowlNotifications';
import { growlShape, matchShape } from '../../../../../components/prop-types';
import { withAccount } from '../../../../../components/AccountContext';

const SUPERLINK_FILE_IMPORT = gql`
query respondentImport($accountId: ID!, $respondentImportId: ID!) {
  account(id: $accountId) {
    id
    respondentImport(respondentImportId: $respondentImportId) {
      id
      fileName
      status
      messages
      createdOn
      updatedOn
      superLink {
        id
        name
      }
    }
  }
}
`;

class ImportFileDetailContainer extends Component {
  render() {
    const { growl, match: { params }, currentAccount } = this.props;
    const variables = {
      accountId: currentAccount,
      respondentImportId: params.importFileId,
    };
    return (
      <Query
        query={SUPERLINK_FILE_IMPORT}
        variables={variables}
      >
        {({ loading, error, data }) => {
          if (error) {
            growlErrors(growl, error);
            return `Error ${error.message}`;
          }

          if (loading) {
            return <Loading />;
          }

          const { account } = data;
          return (
            <ImportFileDetail
              data={account}
            />
          );
        }}
      </Query>
    );
  }
}

ImportFileDetailContainer.propTypes = {
  growl: growlShape.isRequired,
  match: matchShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withAccount(
  withRouter(
    withGrowl(ImportFileDetailContainer),
  ),
);
